import React from "react";
import {
  Th,
  Flex,
  chakra,
} from "@chakra-ui/react";
import { TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";

/**
 * A reusable Table Header (Th) component that indicates sortability and current sort state.
 * @param {string} sortKeyName - The key used for sorting this column (e.g., 'epoch', 'timestamp').
 * @param {Function} handleSort - The function to call when the header is clicked.
 * @param {string} currentSortKey - The key of the currently sorted column.
 * @param {'asc' | 'desc'} currentSortDirection - The current sort direction.
 * @param {ReactNode} children - The content of the header (e.g., "Epoch").
 * @param {object} props - Any additional props to pass to the Th element.
 * @returns {JSX.Element}
 */
const SortableTh = ({ sortKeyName, handleSort, currentSortKey, currentSortDirection, children, ...props }) => {
  const isSorting = currentSortKey === sortKeyName;
  const sortIcon = isSorting ? (
    currentSortDirection === "desc" ? (
      <TriangleDownIcon aria-label="sorted descending" boxSize={3} />
    ) : (
      <TriangleUpIcon aria-label="sorted ascending" boxSize={3} />
    )
  ) : null;

  return (
    <Th
      onClick={() => handleSort(sortKeyName)}
      cursor="pointer"
      _hover={{ color: "gray.200" }}
      borderBottomColor="#56577A" // Keeping consistent style
      color="gray.400" // Keeping consistent style
      fontFamily="Plus Jakarta Display" // Keeping consistent style
      {...props} // Spread any additional props
    >
      <Flex align="center">
        {children}
        {isSorting && <chakra.span pl="1">{sortIcon}</chakra.span>}
      </Flex>
    </Th>
  );
};

export default SortableTh;
